<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="dmv-search-results inner-home">
    <div class="container">
        <div class="row no-margin">
            <!--heading section starts here-->
            <div class="col-6 col-sm-2 mt-4 ">
               <a >
             <button class="btn btn-primary btn-back top-back-button"
              (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
          </a>                   
            </div>

            <div class="col-12 col-sm-8 mt-4">
                <div id="searchResu">Customize Your Order</div>
                <p id="addthereco">Registration {{registrationNumber+1}} of
                    {{dmvStoreService.registrationsInCart?.dmvRegistrations?.length}} </p>
            </div>


            <div class="col-6 col-sm-2 icon-cart mt-4">
                <dmv-shoping-cart [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations"  (clickEvent)="moveToRegistration($event)">
                </dmv-shoping-cart>
            </div>

            <!--heading section ends here-->


            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                {{errorMessage}}
            </div>

            <div class="row mt-4 width100" >
                <div class="col-12 col-sm-6">
                    <div class="card card-main">
                        <div class="1">
                            <div class="card-img"
                                *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.imageCode">
                                <img src="{{globalService.externalResourcesUrl}}dmv/{{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.imageCode}}.jpg"
                                    class="img-fluid"
                                    alt="{{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.altText}}">
                            </div>
                            <div class="card-img"
                                *ngIf="!dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.imageCode">
                                <span class="noTag noTagBig">
                                   <span class="noTagText"> Plate Style Image Not Available</span>
                                </span>
                            </div>
                        </div>

                       


                        <div class="card-body">

                            <div class="col-12">
                                <div class="rectangle-wrapper">
                                    <div id="pin">plate:</div>
                                    <div id="card-subheading">
                                        {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration.licensePlate}}
                                    </div>
                                </div>
                            </div>


                            <div class="col-12">
                                <div class="rectangle-wrapper">
                                    <div id="pin">Make:</div>
                                    <div id="card-subheading">
                                        {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration.makeModel}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="rectangle-wrapper">
                                    <div id="pin">PLATE STYLE:</div>
                                    <div id="card-subheading">
                                        {{(dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.altText)}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12"
                                *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration.allowPlateChange && (dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.allowPlateChange">
                               <section *ngIf="!isPlatePersonalized(dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.currentTagCode) && !isPlateAmateur(dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.currentTagCode); else warningText ">
                                <a class="choose-plate" (click)="changePlate()">
                                    <h5 
                                        [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">
                                        Change Plate (optional)</h5>
                                    <i class="icon-group-10"> <svg-image  [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig.primaryColor" name="Group-10" [width]="20" [height]="20"></svg-image>
                                    </i>
                                </a>
                            </section>
                            <ng-template #warningText >
                                <section class="plateWarningText" *ngIf="isPlatePersonalized(dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.currentTagCode); else amateurPlateWarning">
                                    Personalized plate; plate style cannot be changed online
                                </section>
                                <ng-template #amateurPlateWarning>
                                    <section class="plateWarningText">
                                    Amateur plate; plate style cannot be changed online
                                    </section>
                                </ng-template>
                            </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="col-12" id="iTEMSUMMAR">
                        Item summary
                    </div>

                    <div class="row no-margin">
                        <div class="col-6" id="onYearRene"
                            *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions?.length>0">
                            {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions[dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.selectedRenewalOption-1]?.name}}
                        </div>
                        <div class="col-6" id="moneyTxt"
                            *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions?.length>0">
                            {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.renewalCost | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
                        </div>
                            <div *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].isPlateChange && dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.allowPlateChange && (dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.allowPlateChange"
                                class="col-6" id="onYearRene">Plate Change</div>
                            <div *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].isPlateChange && dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.allowPlateChange && (dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.allowPlateChange"
                                class="col-6" id="moneyTxt">
                                {{(dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.plateStyleCost? dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.plateStyleCost:0) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
                            </div>
                        <div class="col-6" id="onYearRene" *ngIf="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.provideDmvFeeDetails">Other Fees
                            <div class="popover__wrapper">
                                      <i class="icon-group-10"   *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.otherFees!==0"> <svg-image [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig.primaryColor" name="Icon-icon-info-payment" [width]="20" [height]="20"></svg-image>
                                       </i>
                                <div class="popover__content other-fees">
                                    <div
                                        *ngFor="let dmvFee of dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.dmvFees">
                                        <div class="col-12 no-padding popover-brdr-btm"
                                            *ngIf="dmvFee.feeID !== 7 && dmvFee.feeID !== 8 && dmvFee.feeID !== 4 && showMailFee(dmvFee)">
                                            <div class="row no-margin">
                                                <div class="col-6 overlaycart-txt">
                                                    <span>{{dmvFee?.description}}</span>
                                                </div>
                                                <div class="col-6 overlaycart-value">
                                                    <span>{{dmvFee?.amount | number : '1.2-2'  | currency | minusSignToParens}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6" id="moneyTxt" *ngIf="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.provideDmvFeeDetails">
                            {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].otherFees | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
                        </div>

                        <div class="col-12 row no-margin no-padding totalTxt">
                            <div class="col-6" id="onYearRene">TOTAL</div>
                            <div class="col-6" id="totalrupees">{{
                                    dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.totalAmountDue | currency :'USD':'symbol':'1.2-2'  | minusSignToParens
                                }}</div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6" style="padding:0px;">
                <div class="paddingR10"
                    *ngIf="( !dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions  ||dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions?.length===0 ) && dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.allowPlateChange">
                    <div id="renewalOpt" class="mt-4">Renewal Option</div>
                    <div class="form-group">
                        <div class="select-wrapper-3 m-auto">
                            <select class="form-control">
                                <option value="">Plate Change Only</option>

                            </select>

                        </div>
                    </div>
                </div>
                <div class="paddingR10"
                    *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions?.length>0">

                    <div id="renewalOpt" class="mt-4">Renewal Option</div>

                    <div class="form-group">
                        <div class="select-wrapper-3 m-auto">
                            <select class="form-control" (click)="selectChange($event)" (keydown)="selectChangeByKey($event)"  (blur)="setDownIcon($event)" required="required" (change)="setRenewalOption($event)"
                                [value]='dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.selectedRenewalOption'>
                                <option [value]="item.renewalOptionID"
                                    *ngFor="let item of dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions" 
                                    [selected]="isOptionSelected(item.renewalOptionID, dmvStoreService?.registrationsInCart?.dmvRegistrations[registrationNumber]?.selectedRenewalOption, registrationNumber)"
                                    >
                                    {{item.name}} {{item.cost | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</option>

                            </select>
                            <div class="invalid-feedback">Example enter valid renewal option</div>
                        </div><!-- end .select-wrapper -->
                    </div>
                </div>
                <div class="paddingR10 mb-5" *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].isPlateChange">
                    <div id="renewalOpt" class="mt-4">YOU'VE MADE A PLATE CHANGE</div>
                    <div class="card card-main">
                        <dmv-plate-change 
                        [registrationNumber]="registrationNumber" 
                        [newAltText]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.newAltText" 
                        [plateStyleNetChange]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.plateStyleNetChange" 
                        [newImageCode]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.newImageCode" 
                        [plateStyleProcessingCost]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.plateStyleProcessingCost" 
                        [plateStyleRepLacementFee]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.plateStyleRepLacementFee" 
                        [newPlateStyleCost]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.newPlateStyleCost" 
                        ></dmv-plate-change>
                        <div class="undoPlateChangeBtn pr-4 pb-4">
                            <button  class="btn btn-primary  btn-continue m-auto"  (click)="undoPlateChange()">Undo Plate Change
                            </button>
                        </div>
                    </div>
                   
                </div>
                <div *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].registration?.promptForInsurance"
                    class="checkbox-container" data-toggle="modal" data-target="#addInsurance">
                    <label>Add or update insurance information</label>
                    <input type="checkbox" checked="checked">
                    <span class="checkmark"
                        [style.background-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"
                        [style.border-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>
                    <div class="insuranceDetail"
                        *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].globalInsuranceData">
                        {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].globalInsuranceData?.companyName}}
                        ({{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].globalInsuranceData?.companyCode}}),
                        Policy:
                        {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].globalInsuranceData?.policyNumber}}
                    </div>
                    <div id="editInsura" (click)="addUpdateInsuranceInfo()"
                        [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">
                        {{(dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].globalInsuranceData)?"Edit":"Add"}}
                        Insurance Information    <i class="icon-group-10"> <svg-image  [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig.primaryColor" name="Group-10" [width]="20" [height]="20"></svg-image>
                                       </i></div>

                </div>
            </div>





            
        </div>
<div class="m-auto text-center" >
                  <a >
                        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i> Back</button>
                    </a>                    
                    
                   

                <a>
                    <button *ngIf="!(!isHideForPlate && !isHideForRenewal)" class="btn btn-primary  btn-continue m-auto disabled" >Continue
                        <i class="fa fa-chevron-right text-right"></i>
                    </button>

                     <button *ngIf="(!isHideForPlate && !isHideForRenewal)" class="btn btn-primary  btn-continue m-auto"  (click)="continue()">Continue
                        <i class="fa fa-chevron-right text-right"></i>
                    </button>
                </a>
            </div>
    </div>
</div>

<dmv-overlay-plate *ngIf="changePlatePopUpOpen" [registrationNumber]="registrationNumber" [plateData]="plateData"
    [currentTagCode]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.currentTagCode"
    [allowSpecialtyTag]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.allowSpecialtyTag"
    (closeOverlay)="closeOverlay()" (changePlateEvent)="changePlateEvent($event)" (changePlateYes)="changePlateYes($event)" (changePlateNo)="changePlateNo($event)"></dmv-overlay-plate>
<dmv-confirm-model *ngIf="openConfirmModel" (removeConfirm)="removeConfirm()" (continueConfirm)="continueConfirm()">
</dmv-confirm-model>
<dmv-add-update-insurance *ngIf="addUpdateInsurance" (closeAddUpdateInsurance)="closeAddUpdateInsurance()"
    (updateInsurance)="updateInsurance($event)"
    [globalInsuranceData]="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber].globalInsuranceData">
</dmv-add-update-insurance>